import React, { useState } from "react";
import { Table, Modal, message, InputNumber, Alert, Row, Col } from "antd";
import { TOPUP_WAY } from "@/constants/util";
import { confirmRecharge } from "@/api/brand";

const Content = (props) => {
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
    onRefresh = () => {},
  } = props;

  const [viewVisible, setViewVisible] = useState(false);

  const [value, setValue] = useState("");

  const [current, setCurrent] = useState({});

  const [confirmVisible, setConfirmVisible] = useState(false);

  const [infoVisible, setInfoVisible] = useState(false);

  const [image, setImage] = useState([]);

  const handleView = (record) => {
    if (!record.voucherPics) {
      return message.error("暂无凭证！");
    }
    setViewVisible(true);
    setImage(record.voucherPics?.split(",") || []);
  };

  const handleConfirm = (record) => {
    setCurrent(record);
    setValue(record.amount || 0);
    setConfirmVisible(true);
  };

  const handleConfirm1 = () => {
    setConfirmVisible(false);
    setInfoVisible(true);
  };

  const handleConfirm2 = () => {
    setViewVisible(false);

    confirmRecharge({
      id: current.id,
      amount: value,
    }).then((res) => {
      if (res.success) {
        message.success("您已确认充值");
        setValue(0);
        setInfoVisible(false);
        onRefresh();
      }
    });
  };

  const columns = [
    {
      title: "时间",
      dataIndex: "createTime",
      key: "createTime",
    },
    {
      title: "充值方式",
      dataIndex: "mode",
      key: "mode",
      render: (text) => TOPUP_WAY[text],
    },
    {
      title: "充值金额/元",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "账户余额/元",
      dataIndex: "balance",
      key: "balance",
    },
    {
      title: "充值方",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "交易凭证",
      dataIndex: "voucherPics",
      key: "voucherPics",
      render: (text, record) => {
        return record.mode == 4 ? (
          <a href="#" onClick={() => handleView(record)}>
            查看凭证
          </a>
        ) : null;
      },
    },
    {
      title: "对公充值操作人员",
      dataIndex: "employeesName",
      key: "employeesName",
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return record.mode == 4 ? (
          record.state !== 3 ? (
            <a href="#" onClick={() => handleConfirm(record)}>
              确认充值
            </a>
          ) : null
        ) : null;
      },
    },
  ];

  return (
    <div className="bg-white  pt-16 pl-24 pr-24">
      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey="id"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />

      <Modal
        width={520}
        title={"图片预览"}
        bodyStyle={{ height: 550, maxHeight: 550, overflow: "auto" }}
        visible={viewVisible}
        onCancel={() => {
          setViewVisible(false);
          setImage([]);
        }}
        footer={null}
      >
        <div className="image-view">
          {image.map((item) => (
            <img src={item} style={{ width: "100%" }} />
          ))}
        </div>
      </Modal>

      <Modal
        title={"确认充值"}
        visible={confirmVisible}
        onOk={handleConfirm1}
        onCancel={() => {
          setConfirmVisible(false);
          setValue(0);
        }}
        wrapClassName={"alert"}
      >
        <Alert
          type="warning"
          message="确认财务收到对公转账并已核对转账金额，充值后无法撤回！"
          showIcon
        ></Alert>
        <div style={{ display: "flex", alignItems: "center", marginTop: 16 }}>
          <div style={{ marginRight: 16 }}>充值金额：</div>
          <InputNumber
            style={{ width: 260 }}
            value={value}
            onChange={(value) => setValue(value)}
          />
          <div style={{ marginLeft: 8 }}>元</div>
        </div>
      </Modal>

      <Modal
        title={"充值信息确认"}
        visible={infoVisible}
        onOk={handleConfirm2}
        onCancel={() => {
          setConfirmVisible(false);
          setInfoVisible(false);
          setValue(0);
        }}
        wrapClassName={"alert"}
      >
        <Alert
          type="warning"
          message="确认充值信息，充值后无法撤回，请再次核对！"
          showIcon
        ></Alert>
        <Row style={{ marginTop: 10 }}>
          <Col span={4} style={{ textAlign: "right" }}>
            充值方：
          </Col>
          <Col span={10}>{current.companyName}</Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col span={4} style={{ textAlign: "right" }}>
            充值金额：
          </Col>
          <Col span={10}>
            <a href="#">{`${value}元`}</a>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default Content;
